export const StylesHeaderVariables = (theme) => ({
  height: 70,
  get topOffset() {
    return this.height + theme.space.large
  },
  logoWidth: 108,
  logoSubSpacerWidth: theme.space.medium,
  nav: {
    width: 320,
    space: theme.space.base,
  },
  search: {
    maxWidth: 600,
  },
  header: {
    height: theme.height.base,
  },
})
